/** @jsx jsx */
import { __assign, __rest } from "tslib";
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
var defaultStyles = {
    flex: 1,
    overflow: 'auto',
    marginTop: 3 * gridSize(),
};
var contentCSS = function () { return defaultStyles; };
var Content = function (_a) {
    var cssFn = _a.cssFn, props = __rest(_a, ["cssFn"]);
    return (
    /**
     * I noticed the implementation at @atlaskit/checkbox would send the props to cssFn rather
     * than the defaultStyles as the overrides guide suggests. I went with what the overrides
     * guide suggested as it made more sense as a transformer of the current styles rather than
     * a complete override with no chance of partially changing styles.
     */
    jsx("div", __assign({ css: cssFn(defaultStyles) }, props)));
};
export default {
    component: Content,
    cssFn: contentCSS,
};
//# sourceMappingURL=content.js.map